import { createStyles, Theme } from '@mui/material'

const styles = ({ spacing }: Theme) =>
  createStyles({
    userSelector: {
      flex: '1 1 auto',
      marginRight: spacing(4),
    },
    peopleActionsContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    peopleActionsContainerNoUser: {
      justifyContent: 'flex-end',
    },
    editActions: {
      display: 'flex',
    },
    backButton: {
      marginRight: spacing(2),
    },
  })

export default styles
